__webpack_require__.p = "/wp-content/themes/your-catalyst-pathways/js/";